import React, { Component } from "react";

import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalHeader, ModalBody, ModalFooter, Button, Tabs, TabList, TabPanels, Tab, TabPanel, Box, Text, Wrap, WrapItem, Grid, GridItem, Spacer, Image } from '@chakra-ui/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faExclamationCircle } from "@fortawesome/free-solid-svg-icons";


import ConfigService from "../../services/ConfigService";
import CoreService from "../../services/CoreService";
import LocalStorageService from "../../services/LocalStorageService";
import IdentityService from "../../services/IdentityService";
import LocalQueuedDbService from "../../services/LocalQueuedDbService";
import LocalSuspendedDbService from "../../services/LocalSuspendedDbService";

import RoleManager from "../../models/RoleManager.js";
import { AppSecurityKey } from "../../models/AppSecurityKey.js";
import { ObservationSessionMode } from "../../models/ObservationSessionMode.js";

import InitManager from "./Components/Managers/InitManager";
import LookupEntityManager from "./Components/Managers/LookupEntityManager";

import ObservationDebugInfo from "./Components/ObservationDebugInfo";
import FooterButtonStrip from "./Components/FooterButtonStrip";

import BaseCard from "./Components/Cards/BaseCard";

import BGJelly from "../../assets/images/swimmingjellies.png";


export default class LookupEntityModal extends Component {
  constructor(props) {
    super(props);

    this.state =
    {
      schema: null,
      entitySchema: null,
      activeCard: null,
      activeCardId: null,
      showCalculator: false,
      originalValueBag: {},
      valueBag: {},
      errorBag: {}, // [value.id] = {type: "required", message=""}
      onChangeEventsBag: {}, // [value.id] = onChangeEvent
      categoryState: {}, // [category.id]=true|false
      requiredState: {}, // [value.id] = {required: true|false, (message="")}
      onChangeEvents: {},
      showDebugInfo: false,
      isProcessing: false,
      errorMessages: null

    };

    this.configService = new ConfigService();
    this.coreService = new CoreService();
    this.localStorageService = new LocalStorageService();
    this.localQueuedDbService = new LocalQueuedDbService();
    this.localSuspendedDbService = new LocalSuspendedDbService();
    //this.localObsDbService = new LocalDbService("observation", "obsDb", [{field: "offlineId", name: "offlineId", unique: true}]);

    this.init = this.init.bind(this);

    this.onToggleCard = this.onToggleCard.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.onValidationChange = this.onValidationChange.bind(this);

    this.onSaveLookupEntity = this.onSaveLookupEntity.bind(this);
    this.onRemoveLookupEntity = this.onRemoveLookupEntity.bind(this);


    this.onSave = this.onSave.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onToggleDebugRequest = this.onToggleDebugRequest.bind(this);

  }







  onSaveLookupEntity(cardId, cardValue) {
    var newBag = this.state.saveLookupEntityBag;
    newBag[cardId] = { entityKey: cardValue };
    this.setState({ saveLookupEntityBag: newBag });
  }

  onRemoveLookupEntity(cardId) {
    var newBag = this.state.saveLookupEntityBag;
    delete newBag[id];
    this.setState({ saveLookupEntityBag: newBag });
  }


  async componentDidMount() {

    if (this.props.inModalSession) {
      await this.init();
    }

  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.inModalSession !== this.props.inModalSession) {
      console.log("ComponentDidUpdate");
      if (this.props.inModalSession) {
        await this.init();
      }
    }
  }


  async init() 
  {
    // fetch schema
    var schema = await this.localStorageService.getSchema(this.props.schemaId);
    // make entity Key field readonly if COPY
    var entityKeyReadOnly = (this.props.observationSessionMode === ObservationSessionMode.COPY);

    var entitySchema = LookupEntityManager.getEntitySchemaFromSchema(schema, this.props.entityLookupKeyId, entityKeyReadOnly);
    var initialCategoryState = entitySchema.categories[0];
    var initialRequiredState = InitManager.initRequiredState(entitySchema, this.props.observationSessionMode);
    var initialOnChangeEventsBag = InitManager.initOnChangeEvents(entitySchema, this.props.observationSessionMode);


      var originalValueBag = (this.props.initialValueBag);
      this.setState({ originalValueBag: originalValueBag });
      var newValueBag = {};


    if ((this.props.observationSessionMode === ObservationSessionMode.ADD) || (this.props.observationSessionMode === ObservationSessionMode.COPY)) {
      var initialValueBag = InitManager.initFreshValueBag(this.props);
      newValueBag = InitManager.initNewValueBag(schema, initialValueBag);

      if (this.props.observationSessionMode === ObservationSessionMode.COPY) {
        // overwrite with bag passed in as prop.
        Object.keys(this.props.initialValueBag).forEach(key => {
          newValueBag[key] = this.props.initialValueBag[key];
        });
      }
    }





    this.setState({
      schema: schema,
      entitySchema: entitySchema,
      valueBag: newValueBag,
      categoryState: initialCategoryState,
      requiredState: initialRequiredState,
      onChangeEventsBag: initialOnChangeEventsBag
    });
  }

  onToggleDebugRequest()
  {
    var newShowDebugInfo = (RoleManager.hasRoleRights(AppSecurityKey.DEBUG_OBSERVATION, this.props.userSession.token)) ? (!this.state.showDebugInfo) : false;
    this.setState({showDebugInfo: newShowDebugInfo});
  }

  onToggleCard(card) {
    // if we haven't established an active card yet...
    if (this.state.activeCard === null) {
      this.setState({ activeCard: card, activeCardId: card.id, activeSlideCriteria: card.props.card.criteriaSlides, slideFilter: card.id });
      return;
    }
    // tell the previously-active card to lose focus
    // this.state.activeCard.onLoseFocus();
    // if we haven't CHANGED the card, then don't do anything
    if (this.state.activeCard.props.id === card.props.id) {
      this.state.activeCard.onLoseFocus();
      this.setState({
        activeCard: null,
        activeCardId: null
      });
      return;
    };
    // tell the previously-active card to lose focus
    this.state.activeCard.onLoseFocus();
    // reset the slideFilter back to INDIVIDUAL slides
    this.setState({ activeCard: card, activeCardId: card.id, slideFilter: card.id });
  }

  onValueChange(id, value) {
    console.log("New Value: " + value);
    var newValueBag = this.state.valueBag;
    newValueBag[id] = value;
    console.log("On Value Change: " + id + "=" + value);
    this.setState({ valueBag: newValueBag });
  }

  onValidationChange(id, isValid, message) {
    var newErrorBag = this.state.errorBag;
    if (isValid) {
      delete newErrorBag[id];
    } else {
      newErrorBag[id] = { required: true, message: message };
    }
    this.setState({ errorBag: newErrorBag });
  }




  async onSave() {
    try {
      this.setState({ isProcessing: true, errorMessages: null});
      var errorBag = this.validate();
      this.setState({ errorBag: errorBag });
      if (Object.keys(errorBag).length > 0) {
        this.setState({ isProcessing: false });
        var errorMessages = Object.keys(errorBag).map((key) => {return  errorBag[key].message });
        this.setState({errorMessages: errorMessages});
        return;
      }

      var lookupEntityBag = {};
      lookupEntityBag[this.props.entityLookupKeyId] = this.state.valueBag[this.props.entityLookupKeyId];
      var lookupEntities = LookupEntityManager.toLookupEntityList(lookupEntityBag, this.state.valueBag, this.state.schema, this.props.userSession.gcid, this.props.userSession.uid);
      await this.props.onPostRequest(lookupEntities[0]);
    }
    catch (e) {
      var errorMessages = [];
      errorMessages.push("Unexpected error saving Lookup Entity");
      errorMessages.push(e.message);
      this.setState({errorMessages: e})
    }
    finally {
      this.setState({ isProcessing: false });
    }
  }






  onClose() {
    this.setState({ isProcessing: false });
    this.props.onToastRequest('ok', 'Observation entry cancelled', 5000, true);
    //this.props.onHomePageRequest();
    return;
  }


  validate() {
    var newErrorBag = this.state.errorBag;
    // it's possible that we have required field errors already. Let's clear them before re-checking required state.
    var filteredErrorBag = Object.fromEntries(
      Object.entries(newErrorBag).filter(([k, v]) => v.type !== "required")
    );
    // right now we only have required fields. Check the requiredState to fill the errorbag
    Object.keys(this.state.requiredState).forEach((key) => {
      if (!this.state.valueBag[key]) {
        filteredErrorBag[key] = { type: "required", message: this.state.requiredState[key].message };
      }
    });
    return filteredErrorBag;
    /*
    this.setState({ errorBag: filteredErrorBag });
    if (Object.keys(filteredErrorBag).length > 0) {
      this.setState({
        showErrors: true,
        isSaving: false
      });
    */
  }


  render() {
    var colSpan = 1;

    var errorMessage = ((this.state.errorMessages) && (this.state.errorMessages.length > 0)) ?
    this.state.errorMessages.join(",")
    : ""


    return this.props.schemaId &&  this.state.schema ? (

      <Modal
      isOpen={this.props.isOpen}
      onClose={() => this.props.onCloseRequest()}
      scrollBehavior='inside'
      size='xl'
      fontSize='14px'
      
    >
      <ModalOverlay />
      <ModalContent minW="50vw">
        <ModalHeader> 
        {this.props.observationSessionMode === ObservationSessionMode.ADD ? "New Lookup Entity" : "Update " + this.props.entityLookupKeyId}
        
        </ModalHeader>
        <ModalCloseButton/>
        <ModalBody>






      <div >
        <div id="tabs">
          <Tabs id="schema-categories" size='lg' marginBottom="10vh">
            <TabList style={{ position: "sticky", top: 0, left: 0, zIndex: 999, overflow: "hidden" }}>
            <Image src={BGJelly} position={"absolute"} zIndex={-999} top="-200"/>
              {this.state.entitySchema.categories.map((category, index) =>
              (
                <Tab  color={"white"} _selected={{color: "#235991"}} key={category.id} id={category.id} isDisabled={!this.state.categoryState[category.id]}>{category.title}</Tab>
              ))
              }
              <Spacer />
              <Text color={"white"} fontSize={"24px"}>{this.props.schemaId}</Text>
              <Spacer/>
            </TabList>

            <TabPanels>
              {this.state.entitySchema.categories.map((category) =>
              (
                <TabPanel id={category.id + "-panel"}>
                  {category.groups.map((group) =>
                  (

                    <div key={group.title} id={group.title} className="group-title" style={{ borderTopStyle: "solid", fontSize: "23px", borderColor: "#0095c8", borderBottomWidth: "thick", display: 'flex', flexDirection: 'column', marginBottom: '2vh' }}>
                      <Text fontSize={{ base: '18px', md: '28px', lg: '36px' }} >{group.groupTitle}</Text>
                      <Box >
                        {

                          <Grid templateColumns='repeat(auto-fit, minmax(340px,1fr))' gap='6' marginBottom='20px'>
                            {group.cards.map((card, index) => (

                              <GridItem colSpan={(card.colspan) ? card.colspan : 1}>
                                <BaseCard
                                  card={card}
                                  id={card.id}
                                  valueBag={this.state.valueBag}
                                  lookupEntityBag={this.state.saveLookupEntityBag}
                                  userSession={this.props.userSession}
                                  onToggleCard={this.onToggleCard}
                                  onValueChange={this.onValueChange}
                                  onValidationChange={this.onValidationChange}
                                  onSaveLookupEntity={this.onSaveLookupEntity}
                                  onRemoveLookupEntity={this.onRemoveLookupEntity}
                                />

                              </GridItem>

                            ))}
                          </Grid>

                        }
                      </Box>

                    </div>


                  ))
                  }
                </TabPanel>

              ))}

            </TabPanels>
          </Tabs>
        </div>



        {/*
        <div id="footerbuttonstrip" style={{ position: "fixed", bottom: 0, width: "100%", marginBottom: ".5vw" }}>
          <FooterButtonStrip
            userSession={this.props.userSession}
            onMsgBoxRequest={this.props.onMsgBoxRequest}
            observationSessionMode={this.props.observationSessionMode}
            onSaveRequest={this.onSave}
            onCloseRequest={this.onClose}
            onToggleDebugRequest={this.onToggleDebugRequest}
          />
        </div>
        */}


        {
      this.state.showDebugInfo &&
        <ObservationDebugInfo
          debugObservation={this.props.debugObservation}
          observationSessionMode={this.props.observationSessionMode}
          valueBag={this.state.valueBag}
          errorBag={this.state.errorBag}
          categoryState={this.state.categoryState}
          requiredState={this.state.requiredState}
          observationResult={this.state.observationResult}
          onChangeEventsBag={this.state.onChangeEventsBag}
          schema={this.state.entitySchema}
        />
    }


      </div >




            </ModalBody>
            <ModalFooter>
              {((errorMessage !== "")) ? 
                <FontAwesomeIcon color="red" icon={faExclamationCircle}/>
                : <span/>
              }
              <Text color="red">{errorMessage}</Text>
              <Spacer/>
              <Button colorScheme='blue' mr={3} onClick={() => this.onSave()}>
                submit
              </Button>
              <Button colorScheme='blue' mr={3} onClick={() => this.props.onCloseRequest()}>
                cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>





    ) : (
      <div/>
    );
  }
}


